import type {
  Patient,
  Exam,
  CohortKpis,
  CohortDistribution,
  CohortFinding,
  Campaign,
  ReportData,
  RiskTag,
  Status,
} from '../lib/types';

export const mockPatients: Patient[] = [
  {
    id: 'jv',
    optId: 'OPT-061',
    initials: 'JV',
    name: 'Joaquín Vega Nuñez',
    age: 61,
    gender: 'Masculino',
    city: 'Santa Cruz',
    country: 'Bolivia',
    email: 'joaquin.vn@example.com',
    phone: '+591 700-1234',
    optimalScore: 64,
    status: 'crit',
    bioAge: 68.4,
    bioAgeDelta: +7.4,
    findings: 3,
    findingsLevel: 'crit',
    trend: { type: 'new' },
    appointmentState: 'programado',
    appointmentType: 'Seguimiento',
    lastEvaluationAt: '2026-05-05',
    riskTags: ['metabolic', 'cardiovascular'],
  },
  {
    id: 'da',
    optId: 'OPT-050',
    initials: 'DA',
    name: 'Diego Aramayo',
    age: 50,
    gender: 'Masculino',
    city: 'La Paz',
    country: 'Bolivia',
    email: 'daramayo@example.com',
    phone: '+591 711-9988',
    optimalScore: 66,
    status: 'crit',
    bioAge: 56.2,
    bioAgeDelta: +6.2,
    findings: 2,
    findingsLevel: 'warn',
    trend: { type: 'new' },
    appointmentState: 'programado',
    appointmentType: 'Seguimiento',
    lastEvaluationAt: '2026-05-01',
    riskTags: ['cardiovascular'],
  },
  {
    id: 'rs',
    optId: 'OPT-052',
    initials: 'RS',
    name: 'Roberto Salazar Quiroga',
    age: 52,
    gender: 'Masculino',
    city: 'La Paz',
    country: 'Bolivia',
    email: 'rsalazar@example.com',
    phone: '+591 715-3344',
    optimalScore: 72,
    status: 'warn',
    bioAge: 55.8,
    bioAgeDelta: +3.8,
    findings: 3,
    findingsLevel: 'warn',
    trend: { type: 'delta', direction: 'up', value: 4 },
    appointmentState: 'programado',
    appointmentType: 'Seguimiento',
    lastEvaluationAt: '2026-04-30',
    riskTags: ['metabolic'],
  },
  {
    id: 'ml',
    optId: 'OPT-038',
    initials: 'ML',
    name: 'María Fernanda López',
    age: 38,
    gender: 'Femenino',
    city: 'Bogotá',
    country: 'Colombia',
    email: 'mflopez@example.com',
    phone: '+57 320-7788',
    optimalScore: 76,
    status: 'warn',
    bioAge: 41.0,
    bioAgeDelta: +3.0,
    findings: 2,
    findingsLevel: 'warn',
    trend: { type: 'new' },
    appointmentState: 'atendida',
    appointmentType: 'Seguimiento',
    lastEvaluationAt: '2026-04-18',
  },
  {
    id: 'lt',
    optId: 'OPT-035',
    initials: 'LT',
    name: 'Lucía Tapia',
    age: 35,
    gender: 'Femenino',
    city: 'Lima',
    country: 'Perú',
    email: 'ltapia@example.com',
    phone: '+51 998-2211',
    optimalScore: 79,
    status: 'warn',
    bioAge: 36.5,
    bioAgeDelta: +1.5,
    findings: 2,
    findingsLevel: 'warn',
    trend: { type: 'new' },
    appointmentState: 'programado',
    appointmentType: 'Seguimiento',
    lastEvaluationAt: '2026-05-02',
  },
  {
    id: 'pa',
    optId: 'OPT-046',
    initials: 'PA',
    name: 'Paciente Anónimo',
    age: 46,
    gender: 'Masculino',
    city: 'CDMX',
    country: 'México',
    email: 'pa@example.com',
    phone: '+52 555-4422',
    optimalScore: 88,
    status: 'ok',
    bioAge: 42.8,
    bioAgeDelta: -3.2,
    findings: 0,
    findingsLevel: 'ok',
    trend: { type: 'delta', direction: 'up', value: 12 },
    appointmentState: 'programado',
    appointmentType: 'Seguimiento anual',
    lastEvaluationAt: '2026-02-22',
  },
  {
    id: 'cr',
    optId: 'OPT-029',
    initials: 'CR',
    name: 'Camila Restrepo',
    age: 29,
    gender: 'Femenino',
    city: 'Medellín',
    country: 'Colombia',
    email: 'crestrepo@example.com',
    phone: '+57 312-5566',
    optimalScore: 91,
    status: 'ok',
    bioAge: 27.3,
    bioAgeDelta: -1.7,
    findings: 0,
    findingsLevel: 'ok',
    trend: { type: 'new' },
    appointmentState: 'programado',
    appointmentType: 'Seguimiento',
    lastEvaluationAt: '2026-05-02',
  },
  {
    id: 'ev',
    optId: 'OPT-019',
    initials: 'EV',
    name: 'Elena Vargas',
    age: 56,
    gender: 'Femenino',
    city: 'La Paz',
    country: 'Bolivia',
    email: 'evargas@example.com',
    phone: '+591 712-4455',
    optimalScore: 74,
    status: 'warn',
    bioAge: 60.1,
    bioAgeDelta: +4.1,
    findings: 2,
    findingsLevel: 'warn',
    trend: { type: 'new' },
    lastEvaluationAt: '2025-06-12',
    riskTags: ['metabolic'],
  },
  {
    id: 'mb',
    optId: 'OPT-014',
    initials: 'MB',
    name: 'Mauricio Barrios',
    age: 47,
    gender: 'Masculino',
    city: 'Santa Cruz',
    country: 'Bolivia',
    email: 'mbarrios@example.com',
    phone: '+591 717-2266',
    optimalScore: 70,
    status: 'warn',
    bioAge: 52.4,
    bioAgeDelta: +5.4,
    findings: 3,
    findingsLevel: 'warn',
    trend: { type: 'new' },
    lastEvaluationAt: '2024-09-10',
    riskTags: ['cardiovascular'],
  },
  {
    id: 'nf',
    optId: 'OPT-022',
    initials: 'NF',
    name: 'Natalia Fuentes',
    age: 42,
    gender: 'Femenino',
    city: 'Lima',
    country: 'Perú',
    email: 'nfuentes@example.com',
    phone: '+51 994-7733',
    optimalScore: 76,
    status: 'warn',
    bioAge: 44.2,
    bioAgeDelta: +2.2,
    findings: 1,
    findingsLevel: 'warn',
    trend: { type: 'new' },
    lastEvaluationAt: '2025-07-08',
  },
];

export const mockExamsByPatient: Record<string, Exam[]> = {
  jv: [
    {
      id: 'RPT-2026-0505',
      patientId: 'jv',
      panelType: 'core',
      collectedAt: '2026-05-05',
      collectedDay: '05',
      collectedMonth: 'May 26',
      optimalScore: 64,
      status: 'crit',
      biomarkerCount: 42,
      biomarkerCountTotal: 80,
    },
  ],
  da: [
    {
      id: 'RPT-2026-0501',
      patientId: 'da',
      panelType: 'core',
      collectedAt: '2026-05-01',
      collectedDay: '01',
      collectedMonth: 'May 26',
      optimalScore: 66,
      status: 'crit',
      biomarkerCount: 42,
    },
  ],
  rs: [
    {
      id: 'RPT-2026-0430',
      patientId: 'rs',
      panelType: 'apex',
      collectedAt: '2026-04-30',
      collectedDay: '30',
      collectedMonth: 'Abr 26',
      optimalScore: 72,
      status: 'warn',
      biomarkerCount: 60,
      notes: 'Incluye perfil hormonal',
    },
    {
      id: 'RPT-2026-0215',
      patientId: 'rs',
      panelType: 'core',
      collectedAt: '2026-02-15',
      collectedDay: '15',
      collectedMonth: 'Feb 26',
      optimalScore: 68,
      status: 'crit',
      biomarkerCount: 42,
    },
  ],
  ml: [
    {
      id: 'RPT-2026-0418',
      patientId: 'ml',
      panelType: 'core',
      collectedAt: '2026-04-18',
      collectedDay: '18',
      collectedMonth: 'Abr 26',
      optimalScore: 76,
      status: 'warn',
      biomarkerCount: 42,
    },
  ],
  lt: [
    {
      id: 'RPT-2026-0502L',
      patientId: 'lt',
      panelType: 'core',
      collectedAt: '2026-05-02',
      collectedDay: '02',
      collectedMonth: 'May 26',
      optimalScore: 79,
      status: 'warn',
      biomarkerCount: 42,
    },
  ],
  pa: [
    {
      id: 'RPT-2026-0222',
      patientId: 'pa',
      panelType: 'core',
      collectedAt: '2026-02-22',
      collectedDay: '22',
      collectedMonth: 'Feb 26',
      optimalScore: 88,
      status: 'ok',
      biomarkerCount: 42,
      biomarkerCountTotal: 80,
    },
    {
      id: 'RPT-2025-1115',
      patientId: 'pa',
      panelType: 'core',
      collectedAt: '2025-11-15',
      collectedDay: '15',
      collectedMonth: 'Nov 25',
      optimalScore: 76,
      status: 'warn',
      biomarkerCount: 42,
    },
  ],
  cr: [
    {
      id: 'RPT-2026-0502C',
      patientId: 'cr',
      panelType: 'core',
      collectedAt: '2026-05-02',
      collectedDay: '02',
      collectedMonth: 'May 26',
      optimalScore: 91,
      status: 'ok',
      biomarkerCount: 42,
    },
  ],
  ev: [
    {
      id: 'RPT-2025-0612',
      patientId: 'ev',
      panelType: 'core',
      collectedAt: '2025-06-12',
      collectedDay: '12',
      collectedMonth: 'Jun 25',
      optimalScore: 74,
      status: 'warn',
      biomarkerCount: 42,
    },
  ],
  mb: [
    {
      id: 'RPT-2024-0910',
      patientId: 'mb',
      panelType: 'core',
      collectedAt: '2024-09-10',
      collectedDay: '10',
      collectedMonth: 'Sep 24',
      optimalScore: 70,
      status: 'warn',
      biomarkerCount: 42,
    },
  ],
  nf: [
    {
      id: 'RPT-2025-0708',
      patientId: 'nf',
      panelType: 'core',
      collectedAt: '2025-07-08',
      collectedDay: '08',
      collectedMonth: 'Jul 25',
      optimalScore: 76,
      status: 'warn',
      biomarkerCount: 42,
    },
  ],
};

export const mockKpis: CohortKpis = {
  activePatients: 28,
  activePatientsDelta: +3,
  avgScore: 79,
  avgScoreDelta: +2.1,
  avgBioAgeDelta: +2.8,
  avgBioAgeDeltaTrend: +0.3,
  reportsThisMonth: 12,
  reportsProcessed: 9,
  reportsPending: 3,
};

export const mockDistribution: CohortDistribution = {
  ok: { count: 14, pct: 50 },
  warn: { count: 11, pct: 39 },
  crit: { count: 3, pct: 11 },
};

export const mockFindings: CohortFinding[] = [
  {
    name: 'HDL bajo',
    description: '< 40 mg/dL en hombres · < 50 mg/dL en mujeres',
    count: 18,
    pct: 64,
  },
  {
    name: 'HbA1c en zona prediabetes',
    description: '5.7% – 6.4% glicada',
    count: 12,
    pct: 43,
  },
  {
    name: 'TSH elevada',
    description: 'Hipotiroidismo subclínico · > 4.5 mIU/L',
    count: 8,
    pct: 29,
  },
  {
    name: 'ApoB elevada',
    description: 'Riesgo aterosclerótico · > 100 mg/dL',
    count: 6,
    pct: 21,
  },
  {
    name: 'Vitamina D deficiente',
    description: '25-OH < 30 ng/mL',
    count: 5,
    pct: 18,
  },
  {
    name: 'Ferritina baja',
    description: 'Déficit de hierro · < 30 ng/mL',
    count: 4,
    pct: 14,
  },
];

export const mockTrendData = {
  current: 79,
  delta: +2.1,
  months: ['Nov', 'Dic', 'Ene', 'Feb', 'Mar', 'Abr', 'May'],
  // y values matching the SVG polyline
  points: [52, 46, 50, 42, 38, 30, 22],
};

export const mockClinicianName = 'Dr. Andrés Vásquez';
export const mockClinicianInitials = 'AV';

// Care Signals — campañas de ejemplo. Replace with API once campaign service exists.
export const mockCampaigns: Campaign[] = [
  {
    id: 'cmp-001',
    kind: 'metabolic-risk',
    channel: 'whatsapp',
    status: 'active',
    recipientCount: 3,
    createdAt: '2026-05-04',
    sentAt: '2026-05-04',
    metrics: { delivered: 3, opened: 3, responded: 2, scheduled: 1 },
  },
  {
    id: 'cmp-002',
    kind: 'annual-checkup',
    channel: 'email',
    status: 'active',
    recipientCount: 2,
    createdAt: '2026-05-02',
    sentAt: '2026-05-02',
    metrics: { delivered: 2, opened: 1, responded: 0, scheduled: 0 },
  },
  {
    id: 'cmp-003',
    kind: 'no-followup',
    channel: 'whatsapp',
    status: 'completed',
    recipientCount: 5,
    createdAt: '2026-04-08',
    sentAt: '2026-04-08',
    completedAt: '2026-04-22',
    metrics: { delivered: 5, opened: 5, responded: 4, scheduled: 3 },
  },
  {
    id: 'cmp-004',
    kind: 'cardiovascular-risk',
    channel: 'email',
    status: 'completed',
    recipientCount: 4,
    createdAt: '2026-03-15',
    sentAt: '2026-03-15',
    completedAt: '2026-03-29',
    metrics: { delivered: 4, opened: 3, responded: 1, scheduled: 1 },
  },
  {
    id: 'cmp-005',
    kind: 'inactive',
    channel: 'whatsapp',
    status: 'draft',
    recipientCount: 1,
    createdAt: '2026-05-06',
    metrics: { delivered: 0, opened: 0, responded: 0, scheduled: 0 },
  },
];

// Sample clinical report. Currently a single hardcoded record (Paciente Anónimo).
// When the report API lands, fetch by exam id and replace mockReport with the
// fetched payload (typed as ReportData).
export const mockReport: ReportData = {
  id: 'RPT-2026-0222',
  patientId: 'pa',
  patientName: 'Paciente Anónimo',
  patientAge: 46,
  patientGender: 'Masculino',
  patientCity: 'Ciudad de México',
  collectedAt: '22 feb 2026',
  processedAt: '22 feb 2026',
  optimalScore: 88,
  scoreStatus: 'ok',
  bioAge: 36.2,
  chronoAge: 46,
  bioAgeDelta: -9.8,
  alerts: [
    {
      code: 'TSH',
      value: '10.92 mIU/L',
      title: 'TSH elevada',
      description:
        'Compatible con hipotiroidismo. Requiere evaluación con T4 libre y anti-TPO, y referencia a endocrinología.',
      severity: 'crit',
    },
    {
      code: 'TG/ApoB',
      value: '1.15',
      title: 'TG/ApoB',
      description:
        'Ratio bajo sugiere partículas LDL pequeñas y densas, perfil aterogénico residual. Reforzar estrategia lipídica.',
      severity: 'crit',
    },
    {
      code: 'NHR',
      value: '0.087',
      title: 'NHR',
      description:
        'Neutrófilos/HDL bajo. Reevaluar en contexto inflamatorio y de microbiota; considerar marcadores complementarios.',
      severity: 'crit',
    },
  ],
  biomarkerCounts: {
    total: 80,
    ok: 46,
    warn: 31,
    crit: 3,
  },
  biomarkers: [
    { code: 'GLU_FAST', name: 'Glucosa en ayunas', value: '92', unit: 'mg/dL', range: '70 – 99', status: 'ok', kind: 'core', category: 'Metabolismo', barPosition: 58, optimalStart: 25, optimalEnd: 75 },
    { code: 'HBA1C', name: 'Hemoglobina glicosilada', value: '5.4', unit: '%', range: '< 5.7', status: 'ok', kind: 'core', category: 'Metabolismo', barPosition: 55, optimalStart: 0, optimalEnd: 70 },
    { code: 'INSULIN', name: 'Insulina basal', value: '11.2', unit: 'µIU/mL', range: '2.6 – 24.9', status: 'warn', kind: 'core', category: 'Metabolismo', barPosition: 80, optimalStart: 25, optimalEnd: 75 },
    { code: 'HOMA_IR', name: 'HOMA-IR', value: '2.55', unit: '', range: '< 2.0', status: 'warn', kind: 'derived', category: 'Metabolismo', barPosition: 78, optimalStart: 0, optimalEnd: 65 },
    { code: 'TG', name: 'Triglicéridos', value: '88', unit: 'mg/dL', range: '< 150', status: 'ok', kind: 'core', category: 'Lípidos', barPosition: 42, optimalStart: 0, optimalEnd: 65 },
    { code: 'HDL', name: 'HDL colesterol', value: '52', unit: 'mg/dL', range: '> 40', status: 'ok', kind: 'core', category: 'Lípidos', barPosition: 55, optimalStart: 35, optimalEnd: 100 },
    { code: 'LDL', name: 'LDL colesterol', value: '128', unit: 'mg/dL', range: '< 100', status: 'warn', kind: 'core', category: 'Lípidos', barPosition: 78, optimalStart: 0, optimalEnd: 65 },
    { code: 'APOB', name: 'Apolipoproteína B', value: '76', unit: 'mg/dL', range: '< 90', status: 'ok', kind: 'core', category: 'Lípidos', barPosition: 50, optimalStart: 0, optimalEnd: 65 },
    { code: 'TG/APOB', name: 'TG / ApoB', value: '1.15', unit: '', range: '> 1.5', status: 'crit', kind: 'derived', category: 'Lípidos', barPosition: 12, optimalStart: 35, optimalEnd: 100 },
    { code: 'TSH', name: 'Hormona estimulante del tiroides', value: '10.92', unit: 'mIU/L', range: '0.45 – 4.5', status: 'crit', kind: 'core', category: 'Endocrino', barPosition: 92, optimalStart: 25, optimalEnd: 75 },
    { code: 'FT4', name: 'T4 libre', value: '1.05', unit: 'ng/dL', range: '0.82 – 1.77', status: 'ok', kind: 'core', category: 'Endocrino', barPosition: 38, optimalStart: 25, optimalEnd: 75 },
    { code: 'CORT_AM', name: 'Cortisol matutino', value: '14.8', unit: 'µg/dL', range: '6.2 – 19.4', status: 'ok', kind: 'core', category: 'Endocrino', barPosition: 62, optimalStart: 25, optimalEnd: 75 },
    { code: 'HSCRP', name: 'PCR ultrasensible', value: '1.4', unit: 'mg/L', range: '< 1.0', status: 'warn', kind: 'core', category: 'Inflamación', barPosition: 76, optimalStart: 0, optimalEnd: 65 },
    { code: 'NLR', name: 'Neutrófilos / Linfocitos', value: '2.1', unit: '', range: '< 2.5', status: 'ok', kind: 'derived', category: 'Inflamación', barPosition: 55, optimalStart: 0, optimalEnd: 65 },
    { code: 'NHR', name: 'Neutrófilos / HDL', value: '0.087', unit: '', range: '> 0.10', status: 'crit', kind: 'derived', category: 'Inflamación', barPosition: 8, optimalStart: 35, optimalEnd: 100 },
    { code: 'CREAT', name: 'Creatinina', value: '0.96', unit: 'mg/dL', range: '0.7 – 1.3', status: 'ok', kind: 'core', category: 'Renal', barPosition: 48, optimalStart: 25, optimalEnd: 75 },
    { code: 'EGFR', name: 'Filtración glomerular estimada', value: '94', unit: 'mL/min', range: '> 90', status: 'ok', kind: 'derived', category: 'Renal', barPosition: 52, optimalStart: 35, optimalEnd: 100 },
    { code: 'ALT', name: 'Alanina aminotransferasa', value: '24', unit: 'U/L', range: '< 35', status: 'ok', kind: 'core', category: 'Hepático', barPosition: 45, optimalStart: 0, optimalEnd: 65 },
    { code: 'AST', name: 'Aspartato aminotransferasa', value: '22', unit: 'U/L', range: '< 35', status: 'ok', kind: 'core', category: 'Hepático', barPosition: 42, optimalStart: 0, optimalEnd: 65 },
    { code: 'GGT', name: 'Gamma-glutamil transferasa', value: '38', unit: 'U/L', range: '< 55', status: 'warn', kind: 'core', category: 'Hepático', barPosition: 74, optimalStart: 0, optimalEnd: 65 },
    { code: 'VIT_D', name: 'Vitamina D (25-OH)', value: '28', unit: 'ng/mL', range: '30 – 100', status: 'warn', kind: 'core', category: 'Nutrientes', barPosition: 16, optimalStart: 25, optimalEnd: 75 },
    { code: 'VIT_B12', name: 'Vitamina B12', value: '512', unit: 'pg/mL', range: '232 – 1245', status: 'ok', kind: 'core', category: 'Nutrientes', barPosition: 44, optimalStart: 25, optimalEnd: 75 },
    { code: 'FOLATE', name: 'Folato sérico', value: '12.4', unit: 'ng/mL', range: '> 5.4', status: 'ok', kind: 'core', category: 'Nutrientes', barPosition: 60, optimalStart: 35, optimalEnd: 100 },
    { code: 'FERR', name: 'Ferritina', value: '142', unit: 'ng/mL', range: '20 – 250', status: 'ok', kind: 'core', category: 'Nutrientes', barPosition: 50, optimalStart: 25, optimalEnd: 75 },
  ],
  classifiers: [
    { name: 'Salud cardiovascular', score: 70, status: 'warn', description: 'Riesgo aterogénico residual con LDL elevado.', relatedCodes: ['LDL', 'APOB', 'HDL', 'TG/APOB'] },
    { name: 'Salud metabólica', score: 86, status: 'ok', description: 'Glucosa y HbA1c en rango. Resistencia a la insulina leve.', relatedCodes: ['GLU_FAST', 'HBA1C', 'INSULIN', 'HOMA_IR'] },
    { name: 'Carga inflamatoria', score: 100, status: 'ok', description: 'Marcadores inflamatorios sistémicos en rango óptimo.', relatedCodes: ['HSCRP', 'NLR'] },
    { name: 'Salud endocrina', score: 58, status: 'crit', description: 'TSH elevada compatible con hipotiroidismo subclínico.', relatedCodes: ['TSH', 'FT4'] },
    { name: 'Salud hepática', score: 84, status: 'ok', description: 'Enzimas hepáticas dentro del rango óptimo.', relatedCodes: ['ALT', 'AST', 'GGT'] },
    { name: 'Salud renal', score: 92, status: 'ok', description: 'Función renal preservada para edad y sexo.', relatedCodes: ['CREAT', 'EGFR'] },
    { name: 'Estado nutricional', score: 78, status: 'warn', description: 'Vitamina D limítrofe — considerar suplementación.', relatedCodes: ['VIT_D', 'VIT_B12', 'FOLATE'] },
    { name: 'Hematología', score: 96, status: 'ok', description: 'Serie roja, blanca y plaquetaria sin alteraciones.', relatedCodes: ['HGB', 'WBC', 'PLT'] },
    { name: 'Estrés oxidativo', score: 88, status: 'ok', description: 'Marcadores en rango óptimo.', relatedCodes: ['GSH', 'OXLDL'] },
    { name: 'Microbiota intestinal', score: 82, status: 'ok', description: 'Indicadores indirectos sin señales de disbiosis.', relatedCodes: ['NHR', 'GGT'] },
    { name: 'Composición corporal', score: 76, status: 'warn', description: 'IMC y cintura en zona de mejora.', relatedCodes: ['BMI', 'WAIST'] },
    { name: 'Edad biológica', score: 94, status: 'ok', description: 'Edad biológica 9.8 años por debajo de la cronológica.', relatedCodes: ['BIO_AGE'] },
  ],
  intake: [
    {
      category: 'Antropometría',
      answers: [
        { question: 'Estatura', answer: '1.78 m' },
        { question: 'Peso', answer: '82 kg' },
        { question: 'IMC', answer: '25.9' },
        { question: 'Cintura', answer: '94 cm' },
      ],
    },
    {
      category: 'Cobertura médica',
      answers: [
        { question: 'Tipo de cobertura', answer: 'Privada' },
        { question: 'Médico de cabecera', answer: 'Sí' },
        { question: 'Última consulta general', answer: 'Hace 8 meses' },
      ],
    },
    {
      category: 'Actividad física',
      answers: [
        { question: 'Frecuencia', answer: '3-4 días por semana' },
        { question: 'Tipo predominante', answer: 'Fuerza + caminata' },
        { question: 'Pasos diarios promedio', answer: '7,800' },
      ],
    },
    {
      category: 'Sueño',
      answers: [
        { question: 'Horas promedio', answer: '6.5 h' },
        { question: 'Calidad subjetiva', answer: 'Regular' },
        { question: 'Despertares nocturnos', answer: '1-2 por noche' },
      ],
    },
    {
      category: 'Nutrición',
      answers: [
        { question: 'Patrón alimentario', answer: 'Mediterráneo flexible' },
        { question: 'Consumo de ultraprocesados', answer: 'Bajo' },
        { question: 'Hidratación', answer: '2.0 L / día' },
      ],
    },
    {
      category: 'Hábitos',
      answers: [
        { question: 'Tabaco', answer: 'Nunca' },
        { question: 'Alcohol', answer: '3-5 unidades / semana' },
        { question: 'Cafeína', answer: '2 tazas / día' },
      ],
    },
    {
      category: 'Salud mental',
      answers: [
        { question: 'Nivel de estrés (0-10)', answer: '6' },
        { question: 'Ánimo subjetivo', answer: 'Estable' },
        { question: 'Tratamiento psicológico', answer: 'No' },
      ],
    },
    {
      category: 'Síntomas recientes',
      answers: [
        { question: 'Fatiga inusual', answer: 'Sí, en últimas 6 semanas' },
        { question: 'Cambios de peso', answer: 'No' },
        { question: 'Síntomas digestivos', answer: 'Ocasionales' },
      ],
    },
    {
      category: 'Historia clínica',
      answers: [
        { question: 'Cirugías previas', answer: 'Apendicectomía (2014)' },
        { question: 'Hospitalizaciones', answer: 'No' },
        { question: 'Medicamentos actuales', answer: 'Ninguno' },
      ],
    },
    {
      category: 'Alergias',
      answers: [
        { question: 'Medicamentos', answer: 'Penicilina' },
        { question: 'Alimentos', answer: 'No conocidas' },
        { question: 'Ambientales', answer: 'Polen estacional' },
      ],
    },
    {
      category: 'Antecedentes familiares',
      answers: [
        { question: 'Diabetes', answer: 'Padre' },
        { question: 'Cardiovascular', answer: 'Abuelo paterno' },
        { question: 'Tiroides', answer: 'Madre' },
      ],
    },
  ],
  narrative: [
    {
      title: 'Resumen general',
      paragraphs: [
        'Tus resultados muestran un perfil metabólico globalmente saludable, con una edad biológica 9.8 años por debajo de la cronológica. Hay tres marcadores que requieren atención inmediata, principalmente en el eje tiroideo y en el perfil lipídico de partícula.',
        'El score Optimal de 88 te ubica en la franja superior. Los puntos a optimizar son específicos y abordables en las próximas 8-12 semanas con seguimiento clínico.',
      ],
    },
    {
      title: 'Eje tiroideo',
      paragraphs: [
        'Tu TSH de 10.92 mIU/L está claramente por encima del rango óptimo (0.45 – 4.5). Esto es compatible con un cuadro de hipotiroidismo, que puede explicar la fatiga reciente y algunos cambios sutiles en composición corporal.',
        'Recomendación: completar el panel con T4 libre y anti-TPO antes de la próxima consulta, y solicitar referencia con endocrinología. No se requiere ayuno para el seguimiento.',
      ],
    },
    {
      title: 'Perfil lipídico',
      paragraphs: [
        'El LDL de 128 mg/dL está en zona de mejora. Más relevante: tu ratio TG/ApoB de 1.15 sugiere predominio de partículas LDL pequeñas y densas, asociadas a mayor riesgo aterogénico independientemente del LDL absoluto.',
        'Estrategia: reforzar pérdida de grasa visceral, aumentar omega-3 y considerar revisión en 12 semanas para evaluar respuesta a cambios de estilo de vida antes de farmacoterapia.',
      ],
    },
    {
      title: 'Inflamación y microbiota',
      paragraphs: [
        'NHR (neutrófilos/HDL) de 0.087 está ligeramente por debajo del corte óptimo. En contexto de PCR ultrasensible levemente elevada (1.4 mg/L), conviene reevaluar en 8 semanas con marcadores complementarios y un cuestionario de síntomas digestivos.',
      ],
    },
    {
      title: 'Estilo de vida',
      paragraphs: [
        'Tu adherencia a actividad física es buena (3-4 sesiones/semana). El área con mayor margen es el sueño: 6.5 h con calidad subjetiva regular es subóptimo. Apuntar a 7-7.5 h con higiene del sueño consistente puede mejorar marcadores inflamatorios y resistencia a la insulina.',
      ],
    },
    {
      title: 'Próximos pasos',
      paragraphs: [
        'Próxima reevaluación clínica recomendada: 12 semanas. Panel de seguimiento sugerido: TSH, T4 libre, anti-TPO, perfil lipídico ampliado, hsCRP, vitamina D 25-OH.',
        'Esta consulta queda agendada con Dr. Andrés Vásquez.',
      ],
    },
  ],
};

// ─────────────────────────────────────────────────────────────────────────────
// Filler cohort — generated deterministically so the lists / filters can be
// stress-tested at ~100 patients without hand-writing 90 more records.
// Replace with API once available.

function makeRand(seed: number): () => number {
  let s = seed >>> 0;
  return () => {
    s = (Math.imul(s, 1664525) + 1013904223) >>> 0;
    return s / 0x100000000;
  };
}

const F_FIRST = ['Camila', 'Sofía', 'Isabela', 'Valentina', 'Mariana', 'Carolina', 'Daniela', 'Andrea', 'Paula', 'Renata', 'Florencia', 'Catalina', 'Ana', 'Juliana', 'Bianca', 'Macarena', 'Antonia', 'Constanza', 'Emilia', 'Gabriela', 'Patricia', 'Ximena', 'Trinidad', 'Belén'];
const M_FIRST = ['Mateo', 'Sebastián', 'Nicolás', 'Lucas', 'Tomás', 'Gabriel', 'Alejandro', 'Rodrigo', 'Felipe', 'Bruno', 'Ignacio', 'Francisco', 'Esteban', 'Gonzalo', 'Benjamín', 'Cristóbal', 'Vicente', 'Hernán', 'Pablo', 'Ricardo', 'Manuel', 'Eduardo', 'Javier', 'Óscar'];
const LAST = ['Pérez', 'Rodríguez', 'González', 'Martínez', 'López', 'Hernández', 'Gómez', 'Díaz', 'Torres', 'Ruiz', 'Castillo', 'Ramírez', 'Flores', 'Morales', 'Ortiz', 'Silva', 'Romero', 'Mendoza', 'Salinas', 'Cabrera', 'Rivas', 'Serrano', 'Quintero', 'Aguilar', 'Acosta', 'Cordero', 'Navarro', 'Paredes'];
const CITY_COUNTRY: ReadonlyArray<readonly [string, string]> = [
  ['Bogotá', 'Colombia'], ['Medellín', 'Colombia'], ['CDMX', 'México'],
  ['Guadalajara', 'México'], ['Lima', 'Perú'], ['Buenos Aires', 'Argentina'],
  ['Santiago', 'Chile'], ['Quito', 'Ecuador'], ['Montevideo', 'Uruguay'],
  ['La Paz', 'Bolivia'], ['Santa Cruz', 'Bolivia'], ['San José', 'Costa Rica'],
  ['Panamá', 'Panamá'], ['Asunción', 'Paraguay'],
];
const PHONE_PREFIX: Record<string, string> = {
  Colombia: '+57', México: '+52', Perú: '+51', Argentina: '+54',
  Chile: '+56', Ecuador: '+593', Uruguay: '+598', Bolivia: '+591',
  'Costa Rica': '+506', Panamá: '+507', Paraguay: '+595',
};
const RISK_BUCKETS: ReadonlyArray<RiskTag[]> = [[], ['metabolic'], ['cardiovascular'], ['metabolic', 'cardiovascular']];
const APPT_TYPES = ['Seguimiento', 'Primera consulta', 'Seguimiento anual', 'Control mensual'];
const MONTH_LBL = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
const TODAY_REF = new Date('2026-05-08');

function pad2(n: number): string {
  return n.toString().padStart(2, '0');
}

function pickIndex<T>(rand: () => number, arr: ReadonlyArray<T>): number {
  return Math.min(arr.length - 1, Math.floor(rand() * arr.length));
}

function generateFiller(count: number, seed: number): { patients: Patient[]; examsByPatient: Record<string, Exam[]> } {
  const rand = makeRand(seed);
  const patients: Patient[] = [];
  const examsByPatient: Record<string, Exam[]> = {};

  for (let i = 0; i < count; i++) {
    const female = rand() > 0.5;
    const firstPool = female ? F_FIRST : M_FIRST;
    const first = firstPool[pickIndex(rand, firstPool)];
    const last1 = LAST[pickIndex(rand, LAST)];
    const last2 = LAST[pickIndex(rand, LAST)];
    const fullName = `${first} ${last1} ${last2}`;
    const initials = `${first.charAt(0)}${last1.charAt(0)}`.toUpperCase();
    const id = `p${pad2(i + 11).padStart(3, '0')}`;
    const optId = `OPT-${(100 + i).toString().padStart(3, '0')}`;
    const [city, country] = CITY_COUNTRY[pickIndex(rand, CITY_COUNTRY)];
    const age = 25 + Math.floor(rand() * 50);

    const scoreRoll = rand();
    let optimalScore: number;
    let status: Status;
    if (scoreRoll < 0.55) {
      optimalScore = 80 + Math.floor(rand() * 16);
      status = 'ok';
    } else if (scoreRoll < 0.85) {
      optimalScore = 70 + Math.floor(rand() * 10);
      status = 'warn';
    } else {
      optimalScore = 55 + Math.floor(rand() * 15);
      status = 'crit';
    }

    const findings = status === 'ok' ? Math.floor(rand() * 2) : Math.ceil(rand() * 4);
    const findingsLevel: Status = status;
    const bioAgeDelta = parseFloat(((rand() - 0.4) * 10).toFixed(1));
    const bioAge = parseFloat((age + bioAgeDelta).toFixed(1));

    const lastEvalDays = Math.floor(rand() * 800);
    const lastDate = new Date(TODAY_REF);
    lastDate.setDate(lastDate.getDate() - lastEvalDays);
    const lastEvaluationAt = lastDate.toISOString().slice(0, 10);

    const trendRoll = rand();
    const trend: Patient['trend'] = trendRoll < 0.3
      ? { type: 'new' }
      : { type: 'delta', direction: trendRoll < 0.65 ? 'up' : 'down', value: Math.floor(rand() * 8) + 1 };

    const apptRoll = rand();
    const appointmentState = apptRoll < 0.12 ? 'atendida' : apptRoll < 0.35 ? 'programado' : undefined;
    const appointmentType = appointmentState ? APPT_TYPES[pickIndex(rand, APPT_TYPES)] : undefined;

    const tagBucket = RISK_BUCKETS[pickIndex(rand, RISK_BUCKETS)];
    const riskTags = tagBucket.length > 0 ? [...tagBucket] : undefined;

    const phonePrefix = PHONE_PREFIX[country] ?? '+1';
    const phone = `${phonePrefix} ${100 + Math.floor(rand() * 900)}-${1000 + Math.floor(rand() * 9000)}`;
    const emailLocal = `${first.toLowerCase().replace(/[^a-z]/g, '')}.${last1.toLowerCase().replace(/[^a-z]/g, '')}`;
    const email = `${emailLocal}@example.com`;

    patients.push({
      id, optId, initials, name: fullName, age, gender: female ? 'Femenino' : 'Masculino',
      city, country, email, phone, optimalScore, status, bioAge, bioAgeDelta,
      findings, findingsLevel, trend, appointmentState, appointmentType,
      lastEvaluationAt, riskTags,
    });

    const examCount = 1 + Math.floor(rand() * 2);
    const exams: Exam[] = [];
    for (let e = 0; e < examCount; e++) {
      const examDate = new Date(lastDate);
      examDate.setMonth(examDate.getMonth() - e * 4);
      const day = pad2(examDate.getDate());
      const monthLabel = `${MONTH_LBL[examDate.getMonth()]} ${pad2(examDate.getFullYear() % 100)}`;
      const isoDate = examDate.toISOString().slice(0, 10);
      const examScore = e === 0 ? optimalScore : Math.max(40, optimalScore - 1 - Math.floor(rand() * 7));
      const examStatus: Status = e === 0 ? status : status === 'ok' ? 'warn' : status;
      exams.push({
        id: `RPT-${isoDate.replace(/-/g, '')}-${id.toUpperCase()}-${e}`,
        patientId: id,
        panelType: rand() > 0.85 ? 'apex' : 'core',
        collectedAt: isoDate,
        collectedDay: day,
        collectedMonth: monthLabel,
        optimalScore: examScore,
        status: examStatus,
        biomarkerCount: 42,
      });
    }
    examsByPatient[id] = exams;
  }

  return { patients, examsByPatient };
}

const _filler = generateFiller(90, 7777);
mockPatients.push(..._filler.patients);
Object.assign(mockExamsByPatient, _filler.examsByPatient);
